import React from 'react';
import { NewReferralReviewStep } from 'pages/components';

const ScreeningFinalReview = (props) => (
  <NewReferralReviewStep {...props} />
);

export default ScreeningFinalReview;
